export default {
  labels: {
    today: 'Today',
    pickup_time: 'Pickup time',
    delivery_time: 'Delivery time',
  },
};
